import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/QuestionItem.module.css";
import clsx from "clsx";
import { ConfirmModal } from "@components/ConfirmModal";
import { Button } from "react-bootstrap";
import { QuestionFormModal } from "./QuestionFormModal";

const QuestionItem = ({ title, onDelete, onEdit, question }) => {
  // state

  // variables

  // logics before hooks

  // hooks

  // logics

  // UI partials

  // effects

  // render
  return (
    <div
      className={clsx(
        styles.container,
        "py-2 px-3",
        question.isDeleted ? "d-none" : null
      )}
    >
      <div className="d-flex align-items-center">
        <i className="bi bi-lightbulb-fill"></i>

        <span className={clsx("mx-2", styles.title)}>{title}</span>
        {/* {addLectureProcessing?.processing ||
        updateLectureProcessing?.processing ? (
          <Spinner animation="border" size="sm" variant="danger" />
        ) : null} */}

        <QuestionFormModal onSubmit={onEdit} initialValues={question}>
          <button type="button" className="ml-2 opacity-0">
            <i className="bi bi-pencil-square"></i>
          </button>
        </QuestionFormModal>

        <ConfirmModal
          onSubmit={onDelete}
          title={"Confirm Delete"}
          body={"Do you really want to delete this question"}
          submitButton={"Delete"}
        >
          <button type="button" className="ml-2 opacity-0">
            <i className="bi bi-trash-fill"></i>
          </button>
        </ConfirmModal>
      </div>

      <button className="opacity-0">
        <i className="bi bi-list"></i>
      </button>
    </div>
  );
};

/* required: display name */
QuestionItem.displayName = "QuestionItem";

/* required: props types */
QuestionItem.propTypes = {};

/* required: default props */
QuestionItem.defaultProps = {};

export { QuestionItem };
